import React from "react";

const footerLinks = {
  Product: [
    { label: "For Authors", href: "/for-authors" },
    { label: "How It Works", href: "/#how-it-works" },
    { label: "Pricing", href: "/pricing" },
    { label: "Start Publishing", href: "https://app.chapterchronicles.com" },
  ],
  Resources: [
    { label: "Blog", href: "/blog" },
    { label: "Help Center", href: "/docs" },
    { label: "Patreon Alternative", href: "/for-patreon-authors" },
    { label: "Revenue Calculator", href: "/tools/patreon-calculator" },
    { label: "Discover Authors", href: "https://app.chapterchronicles.com/authors" },
    { label: "Login", href: "https://app.chapterchronicles.com/auth/login" },
    { label: "Support", href: "mailto:support@chapterchronicles.com" },
  ],
  Legal: [
    { label: "Privacy Policy", href: "/privacy-policy" },
    { label: "Terms of Service", href: "/terms-of-service" },
    { label: "Community Guidelines", href: "/community-guidelines" },
  ],
};

const Footer = () => {
  return (
    <footer className="bg-[#1E1E1E] text-white py-12 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <h3 className="text-lg font-bold mb-2">Chapter Chronicles</h3>
            <p className="text-sm opacity-80 leading-relaxed max-w-none lg:max-w-[360px] mb-2">
              The all-in-one platform for fiction authors to publish serial
              novels, build communities, and earn recurring income.
            </p>
            <a
              href="mailto:support@chapterchronicles.com"
              className="text-sm opacity-60 hover:opacity-100 transition-opacity"
            >
              support@chapterchronicles.com
            </a>
            <p className="text-sm opacity-60 hidden lg:block mt-2">
              &copy; 2026 Chapter Chronicles. All rights reserved.
            </p>
          </div>

          {/* Link Columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="text-lg font-semibold mb-2">{title}</h3>
              <ul className="flex flex-col gap-1">
                {links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm opacity-80 hover:opacity-100 transition-opacity"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

        </div>

        {/* Mobile copyright */}
        <p className="text-sm opacity-60 mt-8 lg:hidden">
          &copy; 2026 Chapter Chronicles. All rights reserved.
        </p>

        <hr className="border-white/10 my-8" />

        <div className="text-center">
          <p className="text-sm opacity-60">
            Built for fiction authors.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
